import { render, staticRenderFns } from "./TabGeneraDocumento.vue?vue&type=template&id=521b1e02&scoped=true"
import script from "./TabGeneraDocumento.vue?vue&type=script&lang=js"
export * from "./TabGeneraDocumento.vue?vue&type=script&lang=js"
import style0 from "./TabGeneraDocumento.vue?vue&type=style&index=0&id=521b1e02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b1e02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('521b1e02')) {
      api.createRecord('521b1e02', component.options)
    } else {
      api.reload('521b1e02', component.options)
    }
    module.hot.accept("./TabGeneraDocumento.vue?vue&type=template&id=521b1e02&scoped=true", function () {
      api.rerender('521b1e02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabGeneraDocumento.vue"
export default component.exports